import OriginChart from './OriginChart.container';

export default OriginChart;
